import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'p8-layout-settings-page',
  templateUrl: './settings-page.component.html',
  styleUrls: ['./settings-page.component.scss']
})
export class SettingsLayoutPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
